import React, { useState, useEffect } from 'react';
import { Collapse, Input, Checkbox, Space } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const GameSetting = ({ game, winners, onGameChange, onWinnersChange }) => {
  // Initialize the state with the winners prop
  const [winnerInputs, setWinnerInputs] = useState(winners.length > 0 ? winners : ['']);

  useEffect(() => {
    // Ensure the winners are updated when the prop changes
    if (winnerInputs.length === 0 && game) {
      setWinnerInputs(['']);
    } else {
      const validWinners = winnerInputs.map(name => name.trim()).filter(Boolean);
      const uniqueWinners = [...new Set(validWinners)];
      onWinnersChange(uniqueWinners);
    }
  }, [winnerInputs, onWinnersChange, game]);

  const handleWinnerInputChange = (index, value) => {
    const newInputs = [...winnerInputs];
    newInputs[index] = value;
    setWinnerInputs(newInputs);
  };

  const handleAddWinnerInput = () => {
    setWinnerInputs([...winnerInputs, '']);
  };

  const handleRemoveWinnerInput = (index) => {
    const newInputs = winnerInputs.filter((_, i) => i !== index);
    setWinnerInputs(newInputs);
  };

  return (
    <Collapse style={{ margin: 5 }}>
      <Panel header="Game Settings">
        <div style={{ marginBottom: 16 }}>
          <Checkbox checked={game} onChange={e => onGameChange(e.target.checked)}>
            Enable Game
          </Checkbox>
        </div>
        {game && (
          <div>
            {winnerInputs.map((input, index) => (
              <Space key={index} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                <Input
                  placeholder={`Winner ${index + 1}`}
                  value={input}
                  onChange={e => handleWinnerInputChange(index, e.target.value)}
                />
                {winnerInputs.length > 1 && (
                  <MinusCircleOutlined
                    onClick={() => handleRemoveWinnerInput(index)}
                    style={{ color: 'red' }}
                  />
                )}
                {index === winnerInputs.length - 1 && (
                  <PlusOutlined
                    onClick={handleAddWinnerInput}
                    style={{ color: 'green' }}
                  />
                )}
              </Space>
            ))}
          </div>
        )}
      </Panel>
    </Collapse>
  );
};

export default GameSetting;
